import request from "@/service";

/* 查询视频集列表 */
export function videoSetList(data) {
  return request({
    url: `/resource/video/set/page`,
    method: "post",
    data,
  });
}

/* 根据视频名称模糊匹配获取视频列表 */
export function getVideoListByName(data) {
  return request({
    url: `/resource/video/set/getVideoPageByName`,
    method: "get",
    params: data,
  });
}

/* 查询无关联视频列表 */
export function getNoRVideo(data) {
  return request({
    url: `/resource/video/set/getNoRVideo`,
    method: "get",
    params: data,
  });
}

/* 新增视频集 */
export function videoSetSave(data) {
  return request({
    url: `/resource/video/set/save`,
    method: "post",
    data,
  });
}

/* 更新视频集信息 */
export function videoSetUpdate(data) {
  return request({
    url: `/resource/video/set/update`,
    method: "put",
    data,
  });
}

/* 批量删除视频集 */
export function videoSetDelete(data) {
  return request({
    url: `/resource/video/set/delete`,
    method: "delete",
    data,
  });
}

// 关联视频移除
export function deleteRelation(data) {
  return request({
    url: `/resource/video/set/deleteRelation`,
    method: "delete",
    data,
  });
}

/* 上下线 */
export function changeOnlineStatus(data) {
  return request({
    url: `/resource/video/set/online`,
    method: "post",
    data,
  });
}

/* 上下移动 */
export function upAndDown(data) {
  return request({
    url: `/resource/video/set/upAndDown`,
    method: "post",
    data,
  });
}

/* 视频列表 */
export function getVideoList(data) {
  return request({
    url: `/resource/video/set/videoList/${data.uuid}`,
    method: "get",
  });
}

/* 视频列表 */
export function saveRelation(data) {
  return request({
    url: `/resource/video/set/saveRelation`,
    method: "post",
    data,
  });
}
/* 获取视频集详情 */
export function getVideosetInfo(data) {
  return request({
    url: `/resource/video/set/info/${data.uuid}`,
    method: "get",
  });
}

// 视频集共享
export function shareVideoSet(data) {
  return request({
    url: `/resource/video/set/shareVideoSet`,
    method: "put",
    data,
  });
}

// 视频集一键共享
export function shareAllVideoSet(data) {
  return request({
    url: `/resource/video/set/shareAllVideoSet`,
    method: "put",
    data,
  });
}

// 取消视频共享
export function cancelShareVideoSet(data) {
  return request({
    url: `/resource/video/set/cancelShareVideoSet`,
    method: "put",
    data,
  });
}

// 恢复视频共享
export function recoveryVideoSet(data) {
  return request({
    url: `/resource/video/set/recoveryVideoSet`,
    method: "put",
    data,
  });
}

// 视频共享记录
export function videoSetSharePage(data) {
  return request({
    url: `/resource/video/set/sharePage`,
    method: "get",
    params: data,
  });
}

/* 设置上线时间 */
export function setOnlineDate(data) {
  return request({
    url: `/resource/video/set/setOnlineDate`,
    method: "post",
    data,
  });
}

/* 修改视频集展示终端-wangchao */
export function updateDisplay(data) {
  return request({
    url: `/resource/video/set/updateDisplay`,
    method: "post",
    data,
  });
}

export function exportVideoSetList(data) {
  return request({
    url: `/resource/video/set/export`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}

